/** Remove accents of accentuated letters. See https://stackoverflow.com/a/37511463 */
export var removeAccents = function removeAccents(initialString) {
  return initialString.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
/** Original filtering: https://gitlab.com/unifygroup/aufeminin/aufeminin-php/blob/750542fe2333e77b802832ca5042ebbc256ad841/module/Recipe/src/Recipe/Service/RecipeSearchService.php#L69 */

export var removePlural = function removePlural(words) {
  var frenchExceptions = ['baux', 'coraux', 'emaux', 'gemmaux', 'soupiraux', 'travaux', 'vantaux', 'vitraux'];
  return words.map(function (word) {
    if (frenchExceptions.includes(word)) {
      return "".concat(word.slice(0, -2), "il");
    }

    if (word.endsWith('s') || word.endsWith('eaux') || word.endsWith('eux') || word.endsWith('oux')) {
      return word.slice(0, -1);
    }

    if (word.endsWith('aux')) {
      // todo: handle words ending with "au" in singular ?
      return "".concat(word.slice(0, -2), "l");
    }

    return word;
  });
};
export var removeWordsWithFewCharacters = function removeWordsWithFewCharacters(words, minimumNumberOfCharacters) {
  return words.filter(function (word) {
    return word.length >= minimumNumberOfCharacters;
  });
};